export const menuItems = [
  {
    name: "how-it-works",
    label: "How it Works",
    isExternal: false,
  },
  {
    name: "about",
    label: "About",
    isExternal: false,
  },
  {
    name: "contact",
    label: "Contact",
    isExternal: false,
  },
  {
    name: "browse-jobs",
    label: "Browse Jobs",
    isExternal: false,
  },
];
